import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import baffled_plane_circular_piston from "./components/baffled-plane-circular-piston/baffled-plane-circular-piston";
import baffled_plane_square_piston from "./components/baffled-plane-square-piston/baffled-plane-square-piston";
import unbaffled_plane_circular_piston from "./components/unbaffled-plane-circular-piston/unbaffled-plane-circular-piston";

const principle: Slide = {
  description:
    "Three different sources are proposed for illustrating the decomposition on spherical harmonics: baffled or unbaffled plane circular piston of radius a and a baffled square piston of length side a. The pressure field radiated by a source is decomposed on the basis of spherical harmonics and you can select the number of harmonics used for the reconstruction of the directivity pattern. Look how the used number of harmonics needed to match the actual directivity (blue) varies with the ratio of a over the acoustic acoustic wavelength, i.e. with the product of a by the wavevector (k). Note that, for baffled cases, only even harmonics are needed, while for the unbaffled one, only odd harmonics are.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "top",
      controls: [
        {
          type: "button",
          items: [
            { name: "Baffled plane circular piston" },
            { name: "Baffled plane square piston" },
            { name: "Unbaffled plane circular piston" },
          ],
          options: {},
        },
      ],
      extraContent: [[], [], []],
      components: [[baffled_plane_circular_piston], [baffled_plane_square_piston], [unbaffled_plane_circular_piston]],
    },
  },
};

export default principle;
